import { render, staticRenderFns } from "./SubSpecialization.vue?vue&type=template&id=0ef18646&scoped=true"
import script from "./SubSpecialization.vue?vue&type=script&lang=js"
export * from "./SubSpecialization.vue?vue&type=script&lang=js"
import style0 from "./SubSpecialization.vue?vue&type=style&index=0&id=0ef18646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef18646",
  null
  
)

export default component.exports